import script from "./ConfirmMultiple.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmMultiple.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmMultiple.vue?vue&type=style&index=0&id=388e2d4e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388e2d4e"]])

export default __exports__